const useGaTracker = () => {
  let trailerCount = parseInt(localStorage.getItem("trailerCount") || "0");
  console.log("trailerCount", trailerCount);
  function trackTrailerView(trailerTitle: string, trailerUrl: string) {
    // Increment the counter
    trailerCount++;
    localStorage.setItem("trailerCount", trailerCount.toString());

    // Send basic trailer view event
    window.gtag("event", "trailer_view", {
      trailer_title: trailerTitle,
      trailer_url: trailerUrl,
      total_trailers_viewed: trailerCount,
    });

    // Check and fire milestone events
    checkTrailerMilestones(trailerCount);
  }

  function checkTrailerMilestones(count: number) {
    // Fire milestone events for specific counts
    switch (count) {
      case 1:
        window.gtag("event", "trailer_1_viewed", {
          milestone: 1,
          achievement: "first_trailer_viewed",
        });
        break;

      case 10:
        window.gtag("event", "trailer_10_viewed", {
          milestone: 10,
          achievement: "10_trailers_viewed",
        });
        break;

      case 20:
        window.gtag("event", "trailer_20_viewed", {
          milestone: 20,
          achievement: "20_trailers_viewed",
        });
        break;

      case 50:
        window.gtag("event", "trailer_50_viewed", {
          milestone: 50,
          achievement: "50_trailers_viewed",
        });
        break;

      case 100:
        window.gtag("event", "trailer_100_viewed", {
          milestone: 100,
          achievement: "100_trailers_viewed",
        });
        break;
    }
  }

  // Usage: Call this function whenever a user watches a trailer
  function onTrailerWatched(trailerTitle: string, trailerUrl: string) {
    trackTrailerView(trailerTitle, trailerUrl);
  }

  return {
    onTrailerWatched,
    trailerCount,
  };
};

export default useGaTracker;
